"use client";
import { Address } from "@unlockdfinance/verislabs-web3";
import { SupportedChainIds } from "clients/verisModule";
import { useCustomWallet } from "components/providers";
import { useChain } from "components/providers/ChainProvider";
import { handleErrors } from "errors";
import earnModule from "logic/EarnModule";
import { useErrorAlert } from "logic/hooks";
import { IErc20Currency } from "logic/types/currency/ICurrency";
import { useEffect, useState } from "react";

export default function useDepositedBalance(currency?: IErc20Currency) {
  const [balance, setBalance] = useState<bigint>();
  const { address } = useCustomWallet();
  const [error, setError] = useState<Error | null>(null);
  const [sensor, toggle] = useState<boolean>(false);
  useErrorAlert(error);

  useEffect(() => {
    if (address && currency) {
      handleGetDepositedBalance(address, currency);

      return () => setBalance(undefined);
    }
  }, [address, sensor, currency]);

  const handleGetDepositedBalance = async (
    address: Address,
    currency: IErc20Currency
  ) => {
    try {
      const balance = await earnModule.getDepositedBalance(
        currency.address,
        address,
        currency.chain.id
      );

      setBalance(balance);
    } catch (err) {
      setError(handleErrors(err));
    }
  };

  const handleForceUpdate = () => toggle(!sensor);

  return { balance, forceUpdate: handleForceUpdate };
}
